import { render, staticRenderFns } from "./requirementsView.vue?vue&type=template&id=13ab73ab&"
import script from "./requirementsView.vue?vue&type=script&lang=js&"
export * from "./requirementsView.vue?vue&type=script&lang=js&"
import style0 from "./requirementsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports